import React from 'react';
import { Button, Modal } from 'antd';
import { _setAxios, _success } from '../../../../lib/Helper';

class Verification extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false
        };
    }

    handleSubmit = () => {
        this.setState({
            loading: true
        })
        _setAxios("alumni/verifikasi/" + (this.props.data ? this.props.data.id : null), "PUT").then(resp => {
            if (resp.status === true) {
                _success('topRight', 'Success', resp.data.message)
                this.props.fetchTable(true)
                this.props.hideModal()

                this.setState({
                    loading: false
                })
            } else {
                this.setState({
                    loading: false
                });
            }
        })
    };

    render() {

        return (
            <Modal
                maskClosable={false}
                width={300}
                title="Verifikasi data alumni"
                visible={this.props.visible}
                onCancel={this.props.hideModal}
                footer={<>
                    <Button onClick={this.props.hideModal}>Tutup</Button>
                    <Button type='primary' onClick={this.handleSubmit} loading={this.state.loading}>Lanjutkan</Button>
                </>}
            >
                Apakah Anda yakin? <br/>Data alumni tersebut akan di verifikasi.
            </Modal>
        )
    }
}

export default Verification;
